// import React from 'react'
// import * as styled from "./Style"
// import { useNavigate } from 'react-router-dom';


// function EmployeeInformation() {
//     const navigate = useNavigate()

//     const employeeHandle=()=>{
// navigate("/examinstruction")

//     }
//     return (
//        <>
//        <styled.container>
//            <styled.form>
//                <styled.firstname>
//                    <styled.phonelabel>
//                      First Name
//                    </styled.phonelabel>
//                    <styled.phoneinput type="text" placeholder='First Name'/>

                   
//                </styled.firstname>
//                <styled.lastname>
//                    <styled.passlabel>
//                        Last Name
//                    </styled.passlabel>
//                    <styled.passinput type="text" placeholder='Last Name' />
                       
                   
//                </styled.lastname>
//                <styled.email>
//                    <styled.emaillabel>Email</styled.emaillabel>
//                    <styled.emailinput placeholder='Enter Email' type="text" />
//                </styled.email>
//                <styled.gender>
//                    <styled.malelabel>Male</styled.malelabel>
//                    <styled.malecheckbox type="checkbox" />
//                    <styled.femalelabel>Female</styled.femalelabel>
//                    <styled.femalecheckbox  type="checkbox" />
//                </styled.gender>
//                <styled.tenthmarks>
//                    <styled.tenthmarkslabel>
//                        10th Marks (in %)
//                    </styled.tenthmarkslabel>
//                    <styled.tenthmarksinput placeholder='10th Marks' type="text" />
//                </styled.tenthmarks>
//                <styled.twelthmarks>
//                    <styled.tenthmarkslabel>
//                        12th Marks (in %)
//                    </styled.tenthmarkslabel>
//                    <styled.tenthmarksinput placeholder='12th Markd' type="text"/>
//                </styled.twelthmarks>
//                <styled.collegemarks>
//                    <styled.collegemarkslabel>
//                        College Marks (Avg in %)
//                    </styled.collegemarkslabel>
//                    <styled.collegemarksinput placeholder='College Marks' type="text" />
//                </styled.collegemarks>
//                <styled.universityname>
//                <styled.universitynamelabel>
//                            University Name
//                        </styled.universitynamelabel>
//                    <styled.universitynameselect>
                       
//                        <styled.universitynameoption>IIT </styled.universitynameoption>
//                        <styled.universitynameoption>NIT</styled.universitynameoption>
//                        <styled.universitynameoption>UIT</styled.universitynameoption>
//                        <styled.universitynameoption>PIT</styled.universitynameoption>
//                        <styled.universitynameoption>CIT</styled.universitynameoption>
//                        <styled.universitynameoption>one</styled.universitynameoption>
//                        <styled.universitynameoption>one</styled.universitynameoption>
//                        <styled.universitynameoption>one</styled.universitynameoption>
//                        <styled.universitynameoption>one</styled.universitynameoption>
//                        <styled.universitynameoption>one</styled.universitynameoption>
//                        <styled.universitynameoption>OIT</styled.universitynameoption>
//                        <styled.universitynameoption>LIT</styled.universitynameoption>
//                        <styled.universitynameoption>BIT</styled.universitynameoption>

//                    </styled.universitynameselect>
//                </styled.universityname>
//                <styled.passingyear>
//                    <styled.passingyearlabel>
//                        Passing Year
//                    </styled.passingyearlabel>
//                    <styled.passingyearselect>
//                        <styled.passingyearoption>2021</styled.passingyearoption>
//                        <styled.passingyearoption>2022</styled.passingyearoption>
//                        <styled.passingyearoption>2023</styled.passingyearoption>
//                        <styled.passingyearoption>2024</styled.passingyearoption>
//                        <styled.passingyearoption>2025</styled.passingyearoption>
//                        <styled.passingyearoption>2026</styled.passingyearoption>
//                        <styled.passingyearoption>2027</styled.passingyearoption>
//                        <styled.passingyearoption>2028</styled.passingyearoption>

//                    </styled.passingyearselect>
//                </styled.passingyear>
//                <styled.EmployeeInformationbutton onClick={employeeHandle}>
//                    Next
//                </styled.EmployeeInformationbutton>

//            </styled.form>
//        </styled.container>
//        </>
//     )
// }

// export default EmployeeInformation


import React from 'react'
// import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import { Form, Input, Button, Select} from 'antd';
import{useNavigate} from "react-router-dom"
import axios from "axios"

const { Option } = Select;

function EmployeeInformation() {
  // const prefixSelector = (
  //   <Form.Item name="prefix" noStyle>
  //     <Select
  //       style={{
  //         width: 70,
  //       }}
  //     >
  //       <Option value="86">+86</Option>
  //       <Option value="87">+87</Option>
  //     </Select>
  //   </Form.Item>
  // );
        const onFinish = (values) => {
          values.number=parseInt( values.number)

          console.log('Success:', values);


          axios.post("http://localhost:9090/studentdetails",values).then(res=>{
            console.log("++++++ res +++++",res)
            if(res.data.status===200){
                          navigate("/examinstruction")

            }
          }).catch((err)=>{
            console.log("++++++ err +++++++",err)
          })
            // navigate("/employeedetails")

        };
      
        const onFinishFailed = (errorInfo) => {
          console.log('Failed:', errorInfo);
        };

    const navigate = useNavigate()

    
    return (
       <>
       <div style={{
           margin:"20px",
           display:'flex',alignItems:'center',justifyContent:'center'}}>
       <Form
      name="basic"
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 16,
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label="First Name"
        name="fname"
        rules={[
          {
            required: true,
            message: 'Please input your username!',
          },
        ]}
      >
        <Input/>
      </Form.Item>

      <Form.Item
        label="Last Name"
        name="lname"
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="number"
        label="Phone Number"
        rules={[
          {
            required: true,
            message: 'Please input your phone number!',
          },
        ]}
      >
        <Input
          // addonBefore={prefixSelector}
          style={{
            width: '100%',
          }}
        />
      </Form.Item>
    
          <Form.Item
        name="gender"
        label="Gender"
        rules={[
          {
            required: true,
            message: 'Please select gender!',
          },
        ]}
      >
        <Select placeholder="select your gender">
          <Option value="male">Male</Option>
          <Option value="female">Female</Option>
          <Option value="other">Other</Option>
        </Select>
        {/* <Input /> */}
      </Form.Item>
      <Form.Item
        label="College Name"
        name="collegename"
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Address"
        name="addres"
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
        ]}
      >
        <Input.TextArea />
        
      </Form.Item>


     
      <Form.Item
        wrapperCol={{
          offset: 8,
          span: 16,
        }}
      >
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
       </div>
     
       </>
    )
}

export default EmployeeInformation
